import { render, staticRenderFns } from "./AuthRecovery.vue?vue&type=template&id=74f3b5ec"
import script from "./AuthRecovery.vue?vue&type=script&lang=js"
export * from "./AuthRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports